import { ProductV4 } from '../../types/api'

/* Create an array of ids such that each variant barcode will be printed "variant.quantity" times
 *  ex.
 *    if the variants are: [{id: 928, quantity: 2, ...}, {id: 683, quantity: 1, ...}]
 *    output: [928, 928, 683]
 */
export const printableIds = (product: ProductV4) => {
  const { variants } = product

  const ids = []
  variants.forEach(productVariant => {
    let { quantity } = productVariant
    while (quantity > 0) {
      ids.push(productVariant.id)
      quantity -= 1
    }
  })

  return ids
}
